<template>
    <b-card>
        <b-card-header>Customisation</b-card-header>
        <b-card-body>
            <b-form>
                <b-form-row>
                    <b-col cols="4"><h4>Generic Title</h4></b-col>
                    <b-col cols="6"><h4>Customised Title</h4></b-col
                    ><b-col><h4>Required?</h4></b-col>
                </b-form-row>
                <b-form-row>
                    <b-col cols="4">
                        <label
                            id="group-bundled-product"
                            for="input-bundled-product"
                            >Bundled Product</label
                        >
                    </b-col>
                    <b-col cols="6"
                        ><b-form-input
                            id="input-bundled-product"
                            v-model="settingsData.bundledProduct"
                        ></b-form-input> </b-col
                    ><b-col cols="2"></b-col>
                </b-form-row>

                <b-form-row>
                    <b-col cols="4"
                        ><label
                            id="group-secondaryItemsClosingBalances"
                            for="input-secondaryItemsClosingBalances"
                            >Secondary Items Closing Balances</label
                        ></b-col
                    >
                    <b-col cols="6"
                        ><b-form-input
                            id="input-secondaryItemsClosingBalances"
                            v-model="settingsData.secondaryItemsClosingBalances"
                        ></b-form-input> </b-col
                    ><b-col cols="2">
                        <b-form-checkbox
                            id="checkbox-secondaryItemsClosingBalances"
                            v-model="switches.secondaryItemsClosingBalances"
                            name="checkbox-secondaryItemsClosingBalances"
                            :value="true"
                            :unchecked-value="false"
                        ></b-form-checkbox>
                    </b-col>
                </b-form-row>

                <b-form-row>
                    <b-col cols="4"
                        ><label
                            id="group-subProductTotalsBySize"
                            for="input-subProductTotalsBySize"
                            >Sub Products Totals By Size</label
                        ></b-col
                    >
                    <b-col cols="6"
                        ><b-form-input
                            id="input-subProductTotalsBySize"
                            v-model="settingsData.subProductTotalsBySize"
                        ></b-form-input> </b-col
                    ><b-col cols="2">
                        <b-form-checkbox
                            id="checkbox-subProductTotalsBySize"
                            v-model="switches.subProductTotalsBySize"
                            name="checkbox-subProductTotalsBySize"
                            :value="true"
                            :unchecked-value="false"
                        ></b-form-checkbox>
                    </b-col>
                </b-form-row>

                <b-form-row
                    v-for="(heading, idx) in headings"
                    :key="idx + 'heading'"
                >
                    <b-col cols="4"
                        ><label
                            id="fieldset-horizontal"
                            :for="`input-${idx}`"
                            >{{ heading | formatTitle }}</label
                        ></b-col
                    >
                    <b-col cols="6"
                        ><b-form-input
                            :id="`input-${idx}`"
                            v-model="settingsData[heading]"
                        ></b-form-input> </b-col
                    ><b-col cols="2">
                        <b-form-checkbox
                            :id="`checkbox-${heading}`"
                            v-model="switches[heading]"
                            :name="`checkbox-${heading}`"
                            :value="true"
                            :unchecked-value="false"
                        ></b-form-checkbox>
                    </b-col>
                </b-form-row>

                <b-form-row
                    ><b-col cols="4">
                        <label>Bundled Display Type"</label>
                    </b-col>
                    <b-col>
                        <b-form-radio-group
                            v-model="settingsData.bundledProductType"
                            :options="bundledDisplayOptions"
                            name="radio-inline"
                        ></b-form-radio-group>
                    </b-col>
                </b-form-row>

                <b-form-row
                    ><b-col offset="5">
                        <b-button
                            class="float-right"
                            @click="updateConfiguration"
                        >
                            <b-icon
                                v-if="loading"
                                icon="arrow-clockwise"
                                animation="spin"
                            ></b-icon>
                            <span v-else> Update</span>
                        </b-button>
                    </b-col>
                </b-form-row>
            </b-form>
        </b-card-body>
    </b-card>
</template>

<script>
import { capitalCase } from 'change-case'
import settingsMixins from '@/mixins/settingsMixins'
import popupMixins from '@/mixins/popupMixins'
const settingsKeyName = 'inventoryUsageKey'
export default {
    name: 'DailyUsageSettings',
    mixins: [popupMixins, settingsMixins],
    data() {
        return {
            settingsKeyName,
            bundledDisplayOptions: [
                { text: 'Primary Product', value: 'primary' },
                { text: 'Both Products', value: 'both' },
            ],
            settingsData: {},
            switches: {},
            loading: false,
        }
    },
    filters: {
        formatTitle(val) {
            return capitalCase(val)
        },
    },

    props: {
        headings: {
            type: Array,
            require: true,
        },
        formData: { type: Object, default: () => ({}) },
        bundledList: { type: Array, default: () => [] },
        minorList: { type: Array, default: () => [] },
        saveSettingsCounter: { type: Number },
    },
    computed: {
      
    },

    watch: {
        saveSettingsCounter: function () {
            this.updateConfiguration()
        },
        configurationSettings: {
            handler: function (val) {
                this.setSettingsData(val)
            },
            deep: true,
        },
        loading: function (val) {
            this.$emit('set-loading-state', val)
        },
    },

    mounted() {
        const { configurationSettings: settings } = this
        this.setSettingsData(settings)
    },

    methods: {
        setSettingsData(settings) {
            const otherHeadings = [
                'bundledProductType',
                'bundledProduct',
                'subProductTotalsBySize',
                'secondaryItemsClosingBalances',
            ]
            settings = settings || {}

            for (const key of [...this.headings, ...otherHeadings]) {
                const { title, required } = settings[key] || {}
                this.$set(this.settingsData, key, title)
                this.$set(this.switches, key, !!required)
            }

            this.$emit('updating-settings', settings)
        },

        async updateConfiguration() {
            try {
                this.loading = true
                const { settingsData: headings, switches } = this
                const settings = {}

                for (const key in headings) {
                    const title = headings[key]
                    const required = !!switches[key]
                    this.$set(settings, key, { title, required })
                }

                this.$set(settings, 'bundledList', this.bundledList)
                this.$set(settings, 'minorList', this.minorList)
                this.$set(settings, 'formData', this.formData)

                const text_value = JSON.stringify(settings)
                const bool_value = false
                const key = this.settingsKey
                // const { settingsKeyName, settingsKey } = this
                await this.$store.dispatch('company/updateConfiguration', {
                    key,
                    text_value,
                    bool_value,
                })

                this.doToast(
                    'Success',
                    'Settings updated successfully',
                    'success'
                )
            } catch (err) {
                console.error(err.message)
                this.doToast(
                    'Error',
                    `Settings failed to update. ${err.message}`,
                    'danger'
                )
            } finally {
                this.loading = false
            }
        },
    },
}
</script>

<style></style>
